import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class DropdownGoogle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disabled: this.props.disabled,
            error: this.props.error,
            placeholder: this.props.placeholder,
            region: this.props.region,
            places: this.props.places,
            autocomplete_dropdown: false,
            autocomplete_search: "",
            autocomplete_predictions: [],
            inhouse: false,
            country: null
        };
        this.google = window.google;
    };

    componentWillMount() {};

    componentDidMount(){
        this.setState({
            inhouse: this.props.inhouse,
            country: this.props.country?this.props.country:null
        });
        try {
            this.autocomplete = new this.google.maps.places.AutocompleteService();
        } catch (e) {}
        try {
            this.geocoder = new this.google.maps.Geocoder;
        } catch (e) {}
        this.init.search();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            disabled: nextProps.disabled,
            error: nextProps.error,
            placeholder: nextProps.placeholder,
            places: nextProps.places,
            region: nextProps.region,
            inhouse: nextProps.inhouse,
            country: nextProps.country?nextProps.country:null
        });
    }

    init = {
        search: () => {
            if(this.props.value){
                try {
                    this.setState({
                        autocomplete_search: this.props.value.autocomplete_address
                    });
                }catch (e) {}
            }else{
                let search_query = this.state.places[0]?((this.state.places[0]) + " " + (this.state.places[1]?this.state.places[1]:"")):"";
                let self = this;
                this.autocomplete.getPlacePredictions({
                    input: search_query,
                    componentRestrictions: {country: !this.state.inhouse?JSON.parse(salesChannelRegister.get("country_region")).country_code:this.state.country}
                }, function (predictions, status) {
                    if (status === 'OK' && predictions && predictions.length > 0) {
                        self.geocoder.geocode({'placeId': predictions[0].place_id}, function (results, status) {
                            if (status === 'OK' && results && results.length > 0) {
                                self.functions.select(predictions[0], results);
                            }
                        });
                    }
                });
            }
        }
    };

    functions = {
        select: (item, results) => {
           
            this.setState({autocomplete_search: item.structured_formatting.main_text}, () => {
                let parsed_value = {
                    extra: {result: results[0], item: item},
                    autocomplete_lat: results[0].geometry.location.lat(),
                    autocomplete_lng: results[0].geometry.location.lng(),
                    autocomplete_placeid: item.place_id,
                    autocomplete_full_address: item.description,
                    autocomplete_address: item.structured_formatting.main_text
                };
                this.props.onChange(parsed_value, false);
            });
        },
        reset: () => {
            this.setState({
                autocomplete_lat: null,
                autocomplete_lng:null,
                autocomplete_placeid: null,
                autocomplete_full_address: null,
                autocomplete_address: null
            }, () => {
                this.props.onChange(null, this.state.error);
            });
        }
    };

    renders = {};

    render() {
        return (
            <div className={cx(Styles.addressContainer)}>
                <input type={'text'}
                       autoComplete={false}
                       onFocus={() => {
                           this.setState({autocomplete_dropdown: true})
                       }}
                       onBlur={() => {
                           this.setState({autocomplete_dropdown: false})
                       }}
                       value={this.state.autocomplete_search}
                       placeholder={this.state.placeholder}
                       onChange={(event) => {
                           this.setState({autocomplete_search: event.target.value}, () => {
                               if (this.state.autocomplete_search !== this.state.autocomplete_address) {
                                   this.functions.reset();
                               }
                               if (this.state.autocomplete_search && this.state.autocomplete_search !== "") {
                                   this.setState({autocomplete_dropdown: true}, () => {
                                       let self = this;
                                       this.autocomplete.getPlacePredictions({
                                           input: this.state.autocomplete_search,
                                           componentRestrictions: {country: !this.state.inhouse?JSON.parse(salesChannelRegister.get("country_region")).country_code:this.state.country}
                                       }, function (predictions, status) {
                                           if (status === 'OK' && predictions && predictions.length > 0) {
                                               self.setState({autocomplete_predictions: predictions});
                                           } else {
                                               self.setState({
                                                   autocomplete_dropdown: false,
                                                   autocomplete_predictions: []
                                               })
                                           }
                                       });
                                   })
                               } else {
                                   this.setState({
                                       autocomplete_dropdown: false,
                                       autocomplete_predictions: []
                                   })
                               }
                           })
                       }}
                       className={
                           cx(Styles.addressContainerInput,
                               {
                                   [Styles.addressContainerInputError]: this.state.error,
                                   [Styles.addressContainerInputYieldlock]: salesChannelRegister.get('name')==='yieldlock',
                                   [Styles.addressContainerInputErrorYieldlock]: salesChannelRegister.get('name')==='yieldlock' && this.state.error,
                               })
                       }
                />
                {
                    this.state.autocomplete_dropdown && this.state.autocomplete_predictions.length > 0 &&
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={Styles.addressContainerDropdown}>
                        {
                            this.state.autocomplete_predictions.map((item) => {
                                return (
                                    <div onMouseDown={() => {
                                        let self = this;
                                        this.geocoder.geocode({'placeId': item.place_id}, function (results, status) {
                                            if (status === 'OK' && results && results.length > 0) {
                                                self.functions.select(item, results);
                                            }
                                        });
                                    }} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={
                                        cx(Styles.addressContainerDropdownItem,
                                            {
                                                //[Styles.addressContainerDropdownItemYieldlock]: salesChannelRegister.get('name')==='yieldlock',
                                            })
                                    }>
                                        {item.structured_formatting.main_text}
                                        {<div className={Styles.inputDropdownItemParent}>{item.structured_formatting.secondary_text}</div>}
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

export default DropdownGoogle;


// WEBPACK FOOTER //
// ./src/components/dropdown-google/component.js